import { render } from "./PsModal.vue?vue&type=template&id=1dcc699c&scoped=true&ts=true"
import script from "./PsModal.vue?vue&type=script&lang=ts"
export * from "./PsModal.vue?vue&type=script&lang=ts"

import "./PsModal.vue?vue&type=style&index=0&id=1dcc699c&scoped=true&lang=css"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcc699c"]])

export default __exports__